import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { LinkedinAccountSyncStages } from 'features/co-pilot/linkedin-accounts/linkedin-accounts.types';
import SyncStagesStepper from './sync-stages-stepper';

interface Props {
  open: boolean;
  syncStage: LinkedinAccountSyncStages | null;

  handleClose(): void;
}

const AutoSyncProcessingDialog: React.FC<Props> = ({ open, syncStage, handleClose }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('waitForAccountSyncTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={2}>
          <Stack gap={1}>
            <Typography className={classes.text}>{t('waitForAccountSyncContent1')}</Typography>
            <Typography className={cx(classes.text, 'highlight')}>{t('waitForAccountSyncContent2')}</Typography>
            <Typography className={classes.text}>{t('waitForAccountSyncContent3')}</Typography>
          </Stack>
          <SyncStagesStepper activeSyncStage={syncStage} />
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '16px 16px 24px 16px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(14),
    whiteSpace: 'pre-wrap',
    '&.highlight': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default AutoSyncProcessingDialog;
